// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes rotate-4d15646c {
0% {
    transform: rotateZ(0deg);
}
50% {
    transform: rotateZ(180deg);
}
100% {
    transform: rotateZ(360deg);
}
}
.loading-icon[data-v-4d15646c] {
  animation: rotate-4d15646c 2s infinite linear;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
